<template>
  <div class="user">
    <h1>User List</h1>

    <el-form :inline="true" :model="eventForm" ref="eventForm" class="form-inline">
      <el-form-item>
        <el-cascader :options="options" ref="eventCascader" @change="elCascaderOnlick" :show-all-levels="false" placeholder="Select"></el-cascader>
      </el-form-item>

      <el-form-item prop="number">
        <el-input v-show="showLoginName" v-model="loginName" placeholder="Login Name" @keyup.enter.native="onSubmit"></el-input>
      </el-form-item>

      <el-form-item>
        <el-button type="success" plain @click="onSubmit" :loading="searching">Search</el-button>
      </el-form-item>

      <el-form-item style="float: right;">
        <el-button type="primary" plain @click="onClickAddUser" :loading="searching">Add User</el-button>
      </el-form-item>
    </el-form>

    <el-table :data="tableData" style="width: 100%" v-show="showUserTable || isLoading" v-loading="isLoading"
              :cell-style="{textAlign: 'center'}"
              :header-cell-style="{textAlign: 'center', background: '#E5E7E9'}">
              <!-- max-height="500" element-loading-background = "rgba(255, 255, 255, .5)"
              element-loading-text = "loading..."
              element-loading-spinner = "el-icon-loading"> -->
      <el-table-column prop="login_name" label="User Name" fixed fit="true">
        <template slot-scope="{row}">{{ row.login_name || '--' }}</template>
      </el-table-column>
      <el-table-column prop="name" label="Name" fixed fit="true">
        <template slot-scope="{row}">{{ row.name || '--' }}</template>
      </el-table-column>
      <el-table-column prop="user_type" :formatter="statusFormatter" label="User Type" fit="true"
                       :filters="[{ text: 'System Admin', value: '1' }, { text: 'Admin', value: '2' }]"
                       :filter-method="filterTag" filter-placement="bottom-end">
      </el-table-column>
      <el-table-column prop="email" label="Email">
        <template slot-scope="{row}">{{ row.email || '--' }}</template>
      </el-table-column>
      <el-table-column prop="last_login_ip" label="Last Login IP">
        <template slot-scope="{row}">{{ row.last_login_ip || '--' }}</template>
      </el-table-column>
      <el-table-column prop="login_time" :formatter="dateFormatter" empty-text="N/A" label="Last Login Time [as UTC(+00:00)]" fit="true"></el-table-column>
      <el-table-column prop="logoff_time" :formatter="dateFormatter" empty-text="N/A" label="Last Logout Time [as UTC(+00:00)]" fit="true"></el-table-column>
      <el-table-column label="Action">
        <template slot-scope="scope">
<!--          <el-button type="text" size="mini" @click="editUser(scope.$index, scope.row)">Edit</el-button>
          <el-button type="text" size="mini" @click.native.prevent="deleteUser(scope.$index, scope.row)">Delete</el-button>-->
          <el-button-group>
            <el-tooltip class="item" effect="dark" content="Edit User" placement="top">
              <el-button type="primary" plain icon="el-icon-edit" @click="editUser(scope.$index, scope.row)"></el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="Delete User" placement="top">
              <el-button type="primary" plain icon="el-icon-delete" @click.native.prevent="deleteUser(scope.$index, scope.row)"></el-button>
            </el-tooltip>
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>

  </div>
</template>

<script>
import {getUserList, deleteUser, searchUser} from '../api'
import moment from 'moment'
export default {
  name: 'User',
  data () {
    return {
      isLoading: false,
      searching: false,
      showCenterDialog: false,
      showUserTable: false,
      tableData: [],
      options: [{
        value: 'user_type',
        label: 'User Type',
        children: [{
          value: '1',
          label: 'System Admin'
        }, {
          value: '2',
          label: 'Admin'
        }]
      }, {
        value: 'login_name',
        label: 'Login Name'
      }],
      eventForm: {
      },
      showLoginName: false,
      loginName: '',
      searchParams: {
        search_type: null,
        search_word: null
      }
    }
  },
  mounted: function () {
    this.getDataList()
  },
  methods: {
    getDataList () {
      let that = this
      that.isLoading = true
      getUserList().then(data => {
        that.tableData = data.data
        that.isLoading = false
        that.showUserTable = true
      }).catch(error => {
        if (error) {
          console.log(error.stack)
        }
        that.logining = false
      })
    },
    onSubmit () {
      let that = this
      that.$refs.eventForm.validate((valid) => {
        if (valid) {
          that.searching = true

          console.log('loginName = ')
          console.log(that.loginName)

          that.searchParams.search_word = that.searchParams.search_type === 'user_type' ? that.$refs['eventCascader'].getCheckedNodes()[0].value : that.loginName

          searchUser(that.searchParams.search_type, that.searchParams.search_word).then(data => {
            that.searching = false
            that.tableData = data
            that.showUserTable = true

            console.log('searchEventLog Success -> data')
            console.log(data)
          }).catch(error => {
            if (error) {
              console.log(error.stack)
            }
            that.searching = false
            that.showUserTable = false
          })
        } else {
          console.log('error searching!!')
          return false
        }
      })
    },
    elCascaderOnlick (value) {
      let that = this

      console.log('elCascaderOnlick - value = ', value)
      console.log(that.$refs['eventCascader'].getCheckedNodes()[0].label)
      console.log(that.$refs['eventCascader'].getCheckedNodes()[0].value)

      that.searchParams.search_type = value[0]
      that.showLoginName = value[0] === 'login_name'
    },
    onClickAddUser () {
      console.log('onClickAddUser - Route to UserForm')
      // this.$router.push({ name:'DeleteLicense', params:{ data:row}})
      // this.$router.push({ name:'UserForm'})
      this.$router.push({name: 'UserForm', params: {data: null, action: 'add'}})
    },
    dateFormatter (row, column) {
      let date = row[column.property]
      if (date === undefined) {
        return ''
      }
      return moment.utc(date).format('YYYY-MMM-DD HH:mm:ss', true)
    },
    statusFormatter (row, column) {
      let status = row.user_type
      if (status === 1) {
        return 'System Admin'
      } else {
        return 'Admin'
      }
    },
    editUser (index, row) {
      console.log('editUser')
      console.log(row)
      this.$router.push({name: 'UserForm', params: {data: row, action: 'modify'}})
    },
    deleteUser (index, row) {
      let that = this
      let delJsonData = {}

      this.$confirm('This operation will permanentaly delete this User record. Continue?', 'Hints', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        Object.assign(delJsonData, {'login_name': row.login_name})
        console.log(delJsonData)

        // deleteUser(row.login_name).then(data => {
        deleteUser(delJsonData).then(data => {
          console.log('deleteUser Succeed')
          console.log(data)

          that.isLoading = false
          that.$notify({
            title: 'Success',
            message: 'User is deleted Successfully',
            type: 'success'
          })
          that.getDataList()
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Operation Canceled'
        })
      })
    },
    filterTag (value, row) {
      return row.user_type === value
    },
    filterHandler (value, row, column) {
      const property = column['property']
      return row[property] === value
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .user{
    margin: 0 auto;
    position: relative;
  }
</style>

<style>
.el-table .cell {
  word-break: break-word;
}
</style>



// WEBPACK FOOTER //
// UserList.vue?6cc54f5c